/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceVersion.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/distance-version";

export class AutogenModelDistanceVersion<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceVersionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceVersion extends ModelRow<RowDistanceVersionFields> {
	constructor(values?: Partial<RowDistanceVersionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceVersionFields {
	company_id: string;
	description: string;
	dll_path: string;
	multi_version: string;
	source_id: string;
	version_id: string;
}

